import Button from "@/components/Button";
import { smallerClosingCross } from "@/designSystemIcons";
import { cn } from "@/lib/utils";
import {
  contentLabelsSelector,
  formationsAsListSelector,
} from "@/redux/loadedContent/loadedContentSlice";
import { AppDispatch } from "@/redux/store";
import {
  anyFiltersSelectedSelector,
  clearAllFilters,
  selectedFiltersSelector,
  toggleFilter,
} from "@/redux/tactics/tacticsSlice";
import { useTranslation } from "@repo/shared/i18n";
import { useDispatch, useSelector } from "react-redux";

// Think whether this can be a generic component for all filters
interface TacticActiveFiltersRowProps {
  isInsideFiltersSidebar?: boolean;
}
const TacticActiveFiltersRow = ({
  isInsideFiltersSidebar = false,
}: TacticActiveFiltersRowProps) => {
  const anyFiltersSelected = useSelector(anyFiltersSelectedSelector);
  const selectedFilters = useSelector(selectedFiltersSelector);
  const { positions } = useSelector(contentLabelsSelector);
  const formations = useSelector(formationsAsListSelector);
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();
  return (
    <article
      className={cn(
        anyFiltersSelected
          ? "flex justify-between items-start w-full px-2 desktop:px-0 gap-x-2"
          : "hidden",
        isInsideFiltersSidebar && "py-3 bg-gray-700",
      )}
    >
      <section className="flex desktop:flex-wrap gap-2 w-full overflow-x-auto overflow-y-hidden">
        {selectedFilters.map((filter) => (
          <Button
            key={filter.value}
            variant="primary"
            label={
              filter.category === "positions"
                ? (positions[String(filter.value)]?.name ?? filter.label)
                : filter.category === "formation"
                  ? (formations.find(
                      (formation) => formation.id === filter.value,
                    )?.label ?? filter.label)
                  : filter.label
            }
            onClick={() =>
              dispatch(
                toggleFilter({
                  category: filter.category,
                  value: filter.value,
                  label: filter.label,
                }),
              )
            }
            icon={<span className="fill-white">{smallerClosingCross}</span>}
          />
        ))}
      </section>
      {!isInsideFiltersSidebar && (
        <Button
          variant="tertiary"
          label={t("clearFilters")}
          onClick={() => dispatch(clearAllFilters())}
        />
      )}
    </article>
  );
};

export default TacticActiveFiltersRow;
